import { render } from "./CallToContact.vue?vue&type=template&id=33e9677b&scoped=true"
import script from "./CallToContact.vue?vue&type=script&lang=js"
export * from "./CallToContact.vue?vue&type=script&lang=js"

import "./CallToContact.vue?vue&type=style&index=0&id=33e9677b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e9677b"]])

export default __exports__